// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMSyncIndicator.tsx — PropelMapper sync-status chip.
//
// The local-first signature: a pill that says whether work has left the device.
// States map to the system sync palette — synced (green) · uploading /
// downloading / syncing (blue, animated) · pending (amber) · offline (neutral).
// Active transfer states spin their glyph and carry the 2s pill pulse the system
// reserves for in-progress sync. role="status" so changes are announced.
//
//   <PMSyncIndicator status="uploading" />
//   <PMSyncIndicator status="synced" />
//   <PMSyncIndicator status="offline" showLabel={false} />

const PMSYNC_CSS = `
.pmsync{display:inline-flex;align-items:center;gap:6px;border-radius:var(--pm-radius-pill,999px);padding:4px 11px;font:700 11px/1 var(--pm-font-sans);letter-spacing:.04em;text-transform:uppercase;white-space:nowrap;box-sizing:border-box}
.pmsync--sm{padding:3px 9px;font-size:10px;gap:5px}
.pmsync--icononly{padding:5px;border-radius:50%}
.pmsync-ico{display:inline-flex;flex:0 0 auto}
.pmsync-ico svg{display:block}
.pmsync--synced{background:var(--pm-surface-success);color:var(--pm-success-dark)}
.pmsync--uploading,.pmsync--downloading,.pmsync--syncing{background:var(--pm-surface-info);color:var(--pm-info-dark)}
.pmsync--pending{background:var(--pm-surface-warning);color:var(--pm-warning-dark)}
.pmsync--offline{background:var(--pm-surface-variant);color:var(--pm-fg-2)}
.pmsync-spin{animation:pmsyncSpin .9s linear infinite;transform-origin:center}
.pmsync--active{animation:pmsyncPulse 2s ease-in-out infinite}
@keyframes pmsyncSpin{to{transform:rotate(360deg)}}
@keyframes pmsyncPulse{0%,100%{opacity:1}50%{opacity:.6}}
@media (prefers-reduced-motion: reduce){.pmsync-spin{animation:none}.pmsync--active{animation:none}}
`;

function pmsyncEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmsync-css")) return;
  const s = document.createElement("style"); s.id = "pmsync-css"; s.textContent = PMSYNC_CSS;
  document.head.appendChild(s);
}

const PMSYNC_CFG: any = {
  synced:      { label: "Synced",      active: false },
  uploading:   { label: "Uploading",   active: true },
  downloading: { label: "Downloading", active: true },
  syncing:     { label: "Syncing",     active: true },
  pending:     { label: "Pending",     active: false },
  offline:     { label: "Offline",     active: false },
};

function PMSyncGlyph({ status, d = 13 }: any) {
  const common = { width: d, height: d, viewBox: "0 0 24 24", fill: "none" } as any;
  if (status === "synced")
    return <svg {...common}><path d="M5 13l4 4 10-10" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" /></svg>;
  if (status === "pending")
    return <svg {...common}><circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="2.4" strokeDasharray="2.2 3.4" strokeLinecap="round" /></svg>;
  if (status === "offline")
    return <svg {...common}><circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="2.2" /><path d="M7 7l10 10" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" /></svg>;
  // active transfer states — a spinning arc
  return (
    <svg {...common} className="pmsync-spin">
      <circle cx="12" cy="12" r="8" stroke="currentColor" strokeOpacity="0.28" strokeWidth="2.6" />
      <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeDasharray="13 50" />
    </svg>
  );
}

export function PMSyncIndicator({
  status = "synced",
  showLabel = true,
  size = "md",
  className = "",
  style = {},
  ...rest
}: any) {
  pmsyncEnsureCSS();
  const cfg = PMSYNC_CFG[status] || PMSYNC_CFG.synced;
  const cls =
    "pmsync pmsync--" + status +
    (size === "sm" ? " pmsync--sm" : "") +
    (cfg.active ? " pmsync--active" : "") +
    (showLabel ? "" : " pmsync--icononly") +
    (className ? " " + className : "");
  return (
    <span
      className={cls}
      style={style}
      role="status"
      aria-live="polite"
      aria-busy={cfg.active ? true : undefined}
      aria-label={showLabel ? undefined : cfg.label}
      title={showLabel ? undefined : cfg.label}
      {...rest}
    >
      <span className="pmsync-ico" aria-hidden="true"><PMSyncGlyph status={status} d={size === "sm" ? 12 : 13} /></span>
      {showLabel ? cfg.label : null}
    </span>
  );
}
